import React, { useCallback, useMemo } from 'react';
import { Anchor, Box, Field, FieldTypes } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useDividedStatusFields = () => {
  const { originalLockbox } = useLockboxDetailsStore();

  const handleRedirectToDividedDocument = useCallback((documentId?: string) => {
    if (documentId) {
      window.open(ROUTES.LOCKBOX_DETAILS(documentId), '_blank');
    }
  }, []);
  
  const fields: Field[] = useMemo(() => [
    {
      type: FieldTypes.Node,
      name: 'dividingMode',
      label: 'Dividing mode:',
      value: (
        <Box>
          {originalLockbox?.childRecords?.map((childRecord, index, array) => (
            <Box key={childRecord?.id} direction="row">
              <Anchor
                style={{ fontWeight: 700 }}
                onClick={() => handleRedirectToDividedDocument(childRecord?.id)}
              >
                {childRecord?.name}
              </Anchor>
              {index !== array.length - 1 && ','}
            </Box>
          ))}
        </Box>
      ),
    }
  ], [originalLockbox, handleRedirectToDividedDocument]);

  return fields;
};

export default useDividedStatusFields;
